module.exports = __webpack_public_path__ + "static/58-901fa6313e4a2d480a57ac60f4b028ea.jpg";